import * as React from 'react';
import styles from './Summary.module.css';
import { AnimatedClickableDiv } from 'components/Map/AnimatedClickableDiv';
import { useTranslation } from 'react-i18next';

type SummaryProps = {
  date: string;
  pins: number;
  onEditClick: () => void;
};

export const Summary: React.FC<SummaryProps> = ({ date, pins, onEditClick }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        <div className={styles.date}>{date}</div>
        <div className={styles.pins}>{t('{{count}} Pins', { count: pins })}</div>
      </div>
      <AnimatedClickableDiv
        className={styles.iconContainer}
        clickedClassName={styles.iconContainerClicked}
        onClick={onEditClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
        >
          <path
            d="M6.29548 15.0462L1.10352 16.5L2.55727 11.3081L12.0643 1.84714C12.1718 1.73725 12.3002 1.64993 12.4417 1.59032C12.5834 1.53071 12.7356 1.5 12.8893 1.5C13.043 1.5 13.1951 1.53071 13.3368 1.59032C13.4784 1.64993 13.6068 1.73725 13.7142 1.84714L15.7564 3.90085C15.8645 4.00811 15.9503 4.13572 16.009 4.27631C16.0676 4.41691 16.0977 4.56772 16.0977 4.72003C16.0977 4.87234 16.0676 5.02315 16.009 5.16374C15.9503 5.30434 15.8645 5.43195 15.7564 5.53921L6.29548 15.0462Z"
            stroke="#3AA0FF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </AnimatedClickableDiv>
    </div>
  );
};
